
import { Component, Vue } from "vue-property-decorator"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import PictureUpload from "@/components/Account/PictureSelect.vue"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

@Component({
	components: {
		"page": PageWrapper,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"picture-upload": PictureUpload
	}
})
export default class Account extends Vue {
}
